"use client";

import { useState } from "react";
import type { ScenarioCard as ScenarioCardData } from "@lib/agent/conversation/types";
import type { ConversationDifficulty } from "../types";
import { DifficultySelector } from "./DifficultySelector";

type ScenarioCardProps = {
  card: ScenarioCardData;
  defaultDifficulty: ConversationDifficulty;
  selected: boolean;
  loading: boolean;
  onSelect: (card: ScenarioCardData, difficulty: ConversationDifficulty) => void;
};

export function ScenarioCard({
  card,
  defaultDifficulty,
  selected,
  loading,
  onSelect,
}: ScenarioCardProps) {
  const [difficulty, setDifficulty] = useState<ConversationDifficulty>(defaultDifficulty);

  return (
    <div
      className={`surface-card w-full rounded-2xl border-l-4 border-speaking p-4 text-left transition-colors ${
        selected ? "inset-segment-active bg-speaking-tint ring-2 ring-speaking/30" : ""
      }`}
    >
      <button
        type="button"
        disabled={loading}
        onClick={() => onSelect(card, difficulty)}
        className="w-full rounded-lg text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-speaking"
        style={{ minHeight: "44px" }}
      >
        <p className="eyebrow text-ink-faint">{card.setting}</p>
        <h3 className="font-display text-base font-semibold text-ink">{card.title}</h3>
        <p className="mt-1 line-clamp-2 text-sm text-ink-muted">{card.grammarFocus}</p>
      </button>
      <DifficultySelector value={difficulty} onChange={setDifficulty} disabled={loading} />
    </div>
  );
}
